import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
} from 'react';
import {
  AzureAD, AuthenticationState, LoginType, MsalAuthProvider,
} from 'react-aad-msal';
import { Logger, LogLevel } from 'msal';
import Entries from '../components/entries';
import EntryForm from '../components/entryform';
import config from '../global/config';
import Feedback from '../icons/feedback';
import Logo from '../icons/logo';
import Context from '../utils/context';
import basicReduxStore from './reduxStore';

const Main = () => {
  const useComponentDidMount = (func) => useEffect(func, []);
  const useComponentWillMount = (func) => {
    const willMount = useRef(true);
    if (willMount.current) {
      func();
    }
    useComponentDidMount(() => {
      willMount.current = false;
    });
  };
  // Run health check before mount
  useComponentWillMount(() => {
    const url = config.healthUri();
    const opts = {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': config.apiHost(),
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
    const request = async () => {
      try {
        const res = await fetch(url, opts);
        if (res && res.status === 200) {
          Object.assign(config.principal, { mock: false });
        }
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
    };
    request();
  });
  // Global state
  const [valueGlobal, setValueGlobal] = useState(true);
  const incrementValueGlobal = () => setValueGlobal(true);
  const decrementValueGlobal = () => setValueGlobal(false);
  //  FIX: memoize context value to avoid eslint error
  const contextValue = useMemo(
    () => ({
      valueGlobalState: valueGlobal,
      addGlobalValue: () => incrementValueGlobal(),
      decGlobalValue: () => decrementValueGlobal(),
    }),
    [valueGlobal],
  );
  //  FIX: avoid calling login in JSX render
  useEffect(() => {
    let interval;
    // eslint-disable-next-line no-unused-vars
    const startLogin = async (loginfun) => {
      interval = setInterval(() => {
        loginfun();
      }, 5000);
    };
    return () => clearInterval(interval);
  }, []);
  return (
    <div>
      <AzureAD
        provider={new MsalAuthProvider(
          {
            auth: {
              authority:
                'https://login.microsoftonline.com/4b0911a0-929b-4715-944b-c03745165b3a',
              clientId: '03197a41-5cfd-4f9b-8001-1d3c197c22b4',
              redirectUri: `${window.location.origin}/admin/`,
              postLogoutRedirectUri: `${window.location.origin}/admin/`,
              validateAuthority: true,
              navigateToLoginRequestUrl: false,
            },
            system: {
              logger: new Logger(
                () => {},
                {
                  level: LogLevel.Verbose,
                  piiLoggingEnabled: false,
                },
              ),
            },
            cache: {
              cacheLocation: 'sessionStorage',
              storeAuthStateInCookie: false,
            },
          },
          { scopes: ['openid'] },
          {
            loginType: LoginType.Redirect,
            tokenRefreshUri: `${window.location.origin}/auth.html`,
          },
        )}
        reduxStore={basicReduxStore}
      >
        {({ login, accountInfo, authenticationState }) => (
          <Context.Provider value={contextValue}>
            {authenticationState === AuthenticationState.Unauthenticated && (
              <div>
                {/* trigger login side effect */}
                {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                {useEffect(() => {
                  login();
                }, [login])}
              </div>
            )}
            {authenticationState === AuthenticationState.Authenticated && (
              <div className="luci-site-page-shell">
                <header className="luci-site-page-shell__header">
                  <div className="luci-site-page-shell__header-inner">
                    <div className="luci-site-top-hat">
                      <div className="luci-site-top-hat__utils">
                        <span className="luci-link--small luci-link--on-dark luci-link__text">
                          {`| ${accountInfo.account.name} |`}
                        </span>
                        <span className="luci-link--small luci-link--on-dark luci-link__text">
                          &nbsp;
                        </span>
                        <a
                          className="luci-link luci-link--small luci-link--on-dark"
                          href="mailto:ng-tsi@netapp.com"
                        >
                          <Feedback
                            id="luci-site-feedback"
                            className="luci-icon luci-link__icon luci-link__icon--left"
                            aria-hidden="true"
                          />
                          <span className="luci-link__text">Contact DevExp</span>
                        </a>
                      </div>
                    </div>
                    <div className="luci-site-property-bar">
                      <Logo
                        id="logo"
                        className="luci-site-property-bar__logo"
                      />
                      <span className="luci-site-property-bar__title">
                        <a
                          href="/"
                          className="luci-site-property-bar__home-link"
                        >
                          <h1 className="luci-site-property-bar__name">
                            NetApp Tiny URL Tool
                          </h1>
                        </a>
                      </span>
                    </div>
                  </div>
                </header>
                <div className="luci-site-page-shell__body">
                  <div className="luci-site-page-shell__content">
                    <EntryForm />
                    <div />
                    <Entries />
                  </div>
                  <div className="luci-site-page-shell__site-navigation" />
                </div>
              </div>
            )}
          </Context.Provider>
        )}
      </AzureAD>
    </div>
  );
};
export default Main;
